module.exports = __webpack_public_path__ + "img/UI_common_framelabelBX_02_35ce2b7cd.png";